'use strict';

const cookieName = 'OptanonAlertBoxClosed';

/**
 * Grabs cookie val and returns it
 * @returns {Boolean} Value in cookie
 */
const getAcceptedCookieVal = () => {
    const cookieVal = document.cookie.match('(^|;) ?' + cookieName + '=([^;]*)(;|$)');
    return !!cookieVal;
};

/**
 * Checks if cookies are accepted and returns a boolean.
 * A cookie val of 1 means the user accepted, a val of 2 means the user did not.
 * @returns {Boolean} accepted or not
 */
const cookiesAccepted = () => {
    return getAcceptedCookieVal();
};

module.exports = cookiesAccepted;
